export default __webpack_public_path__ + "static/Black Wordmark no Background-f80cc3ec4d4a907fc0cc795134b5aa54.svg";